import { Component, inject, input, output, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { AnchorCommand } from '@src/suite/common/store/story/models/story.models';
import { ProductionCommandFieldsLabelKeys, ProductionCommandType, ProductionFieldName } from '@src/suite/common/utils/ml-2-html-utils';

import { TextFieldComponent } from '../../../controls/text-field/text-field';

@Component({
    selector: 'st-anchor-command-dialog',
    imports: [TextFieldComponent],
    templateUrl: './anchor-command-dialog.html',
    styleUrl: './anchor-command-dialog.scss',
    encapsulation: ViewEncapsulation.None,
    host: { class: 'st-anchor-command-dialog' },
})
export class AnchorCommandDialogComponent {
    // injectables
    store = inject(Store);

    // store signals
    languageSettings = this.store.selectSignal(selectI18N);

    // inputs
    public readonly commands = input<AnchorCommand[]>();

    // outputs
    readonly commandChange = output<AnchorCommand[]>();
    readonly enterEmitter = output<AnchorCommand[]>();

    // constants
    ProductionFieldName = ProductionFieldName;
    ProductionCommandFieldsLabelKeys = ProductionCommandFieldsLabelKeys;
    ProductionCommandType = ProductionCommandType;

    public onCommandsObjectChange(event: any, commandType: ProductionCommandType) {
        if (this.commands() && this.commands().length > 0) {
            if (commandType === ProductionCommandType.ANCHOR) {
                this.commands()[0] = { ...this.commands()?.[0], [ProductionFieldName.TEXT]: event.replace(/:/g, '') };
                this.commandChange.emit(this.commands());
            } else if (commandType === ProductionCommandType.READRATE) {
                this.commands()[1] = { ...this.commands()?.[1], [ProductionFieldName.TEXT]: event.replace(/:/g, '') };
                this.commandChange.emit(this.commands());
            }
        }
    }

    public onEnterSaveCommand(event: any, commandType: ProductionCommandType) {
        this.onCommandsObjectChange(event, commandType);
        this.enterEmitter.emit(this.commands());
    }
}
